// Set :

export const setItem = (storageKey, value) => {
  try {
    localStorage.setItem(storageKey, value);
  } catch(e) {
    // catch -- TODO : debug logging
  }
};

export const setObject = (storageKey, value) => {
  try {
    localStorage.setItem(storageKey, JSON.stringify(value));
  } catch(e) {
    // catch -- TODO : debug logging
  }
};


// Get :

export const getItem = (storageKey) => {
  const storageItem = localStorage.getItem(storageKey);
  return storageItem;
};

export const getObject = (storageKey) => {
  const storageItem = localStorage.getItem(storageKey) || '{}';
  try {
    return JSON.parse(storageItem);
  } catch(e) {
    return null;
  }
};


// Remove :

export const remove = (storageKey) => {
  localStorage.removeItem(storageKey);
};



// WEBPACK FOOTER //
// ./src/modules-es5/commons/lib/lib-storage.js